import { createNamespacedHelpers } from 'vuex'
import { USER_PUT_AGENCY } from '@/store/modules/user/action-types'
import { loadingHandler, toast } from '@/utils/ui'
import { ROUTE_NAME_HOME } from '@/router/routes'
import { DATA_BASE_AGENCY } from '@/consts/data/agencies'

const storeUser = createNamespacedHelpers('user')

export default {
  data () {
    return {
      agency: {}
    }
  },
  watch: {
    _agency: {
      immediate: true,
      handler: 'cloneAgency'
    }
  },
  computed: {
    ...storeUser.mapGetters({
      _agency: 'company'
    })
  },
  methods: {
    ...storeUser.mapActions({
      putAgency: USER_PUT_AGENCY
    }),
    cloneAgency () {
      if (this.$route.query.new) {
        this.agency = _.cloneDeep(DATA_BASE_AGENCY)
      } else {
        this.agency = _.cloneDeep(this._agency)
      }
    },
    onSubmit () {
      const diff = this.agency.id
        ? {}
        : { ...this.agency }
      if (this.agency.id) {
        _.mapValues(this.agency, (v, k) => { // On met à jour seulement le necessaire
          if (!_.isEqual(this._agency[k], v)) {
            diff[k] = v
          }
        })
      }
      return _.isEmpty(diff)
        ? toast.negative('Aucun changement à enregistrer')
        : loadingHandler(async () => {
          diff.id = this.agency.id // On précise bien l'agence en question
          await this.putAgency(diff)
          if (this.$route.query.new) {
            await this.$router.push({ name: ROUTE_NAME_HOME })
          } else {
            toast.info('Vos paramètres ont bien été pris en compte')
          }
        })
    }
  }
}
